import { Component, Input } from '@angular/core';
import { LoanApplication } from 'src/app/models/loan/loan-info.model';

@Component({
    selector: 'tpo-origination-info',
    templateUrl: 'tpo-origination-info.component.html',
    standalone: false
})

export class TpoOriginationInfoComponent {

    private _application: LoanApplication;

    @Input()
    set application(application: LoanApplication) {
        this._application = application;
    }

    get application(): LoanApplication {
        return this._application;
    }


    @Input()
    isPRMG: boolean = false;

    @Input()
    set hiddenFields(hiddenFields: string[]) {
        this.isLockDateHidden = !!hiddenFields?.includes('lockDate');
        this.isCdIssueDateHidden = !!hiddenFields?.includes('cdIssueDate');
        this.isCdSignedDateHidden = !!hiddenFields?.includes('cdSignedDate');
    }

    protected isLockDateHidden: boolean = false;
    protected isCdIssueDateHidden: boolean = false;
    protected isCdSignedDateHidden: boolean = false;

    constructor() { }
}
